import React, { Component } from 'react';
import { flowRight as compose } from 'lodash';
import { injectIntl } from 'react-intl';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import SearchForm from '../SearchForm/SearchForm';
import c from './HeaderLocationSearch.css';
class HeaderLocationSearch extends Component {

    render() {
        const { page, viewListingHeader, guests } = this.props;
        return (
            <div className={'headerSearch'}>
                <SearchForm page={page} viewListingHeader={viewListingHeader} guests={guests} />
            </div>
        )
    }
}

export default compose(
    injectIntl,
    withStyles(c),
)(HeaderLocationSearch);